import { useEffect, useState } from "react";
import axios from "../api/axios"; // your axios instance

export default function BannerSection() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const response = await axios.get("https://cartbackend.wsdstech.com/api/banners");
      setBanners(response.data || []);
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  // Initialize Swiper
  useEffect(() => {
    const initSwiper = () => {
      if (window.Swiper) {
        new window.Swiper(".main-swiper", {
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      } else {
        setTimeout(initSwiper, 100);
      }
    };

    initSwiper();
  }, [banners]); // Re-initialize Swiper whenever banners update

  return (
    <section
      style={{
        backgroundImage: "url('/images/background-pattern.jpg')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="banner-blocks">
              <div className="banner-ad large bg-info block-1">
                <div className="swiper main-swiper">
                  <div className="swiper-wrapper">
                    {banners.length > 0 ? (
                      banners.map((banner, index) =>
                        Array.isArray(banner.images) ? (
                          banner.images.map((img, i) => (
                            <div className="swiper-slide" key={`${index}-${i}`}>
                              <img
                                src={`https://cartbackend.wsdstech.com/storage/${img}`}
                                alt={banner.title}
                                style={{ width: "100%", height: "auto" }}
                              />
                            </div>
                          ))
                        ) : (
                          <div className="swiper-slide" key={index}>
                            <img
                              src={`https://cartbackend.wsdstech.com/storage/${banner.images}`}
                              alt={banner.title}
                              style={{ width: "100%", height: "auto" }}
                            />
                          </div>
                        )
                      )
                    ) : (
                      <div className="swiper-slide" style={{ textAlign: "center", padding: "50px 0" }}>
                        <p>Loading...</p>
                      </div>
                    )}
                  </div>
                  <div className="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
